import { useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useUpdateEffect } from 'react-use'
import { useRecoilState, useRecoilValue } from 'recoil'

import { uploadWork, uploadWorkVideo } from '@/api/room'
import useGetRecoilState from '@/hooks/useGetRecoilState'
import { paramsState, rtmUserState, screenSharingState, useDeviceState } from '@/store/room'
import { downloadImages } from '@/utils/download'

const Index = ({ url, selected, reload }: { url: URL; selected: boolean; reload: number }) => {
  const params = useRecoilValue(paramsState)
  const webviewRef = useRef<HTMLDivElement>(null)
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const canvasRef = useRef<HTMLCanvasElement>(null)
  const animationFrameId = useRef<number>()
  const streamRef = useRef<MediaStream | null>(null)

  useUpdateEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.src = url?.toString()
    }
  }, [reload])

  // 清理函数
  const cleanup = () => {
    if (animationFrameId.current) {
      cancelAnimationFrame(animationFrameId.current)
    }

    // 停止所有视频流轨道
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop())
    }
  }

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      console.log('🚀 ~ onMessage ~ in:', event, url)
      // if (event.origin !== url?.origin) {
      //   // 替换为子页面的实际来源
      //   return
      // }

      try {
        // 尝试解析接收到的数据
        let data: {
          action?: string
          params?: any
        } = {}
        console.log('🚀 ~ onMessage ~ event:', event)

        if (typeof event.data === 'string') {
          data = JSON.parse(event.data)
        } else {
          data = event.data
        }

        console.log('🚀 ~ onMessage ~ urls:', data)
        const { action = '', params: message } = data
        switch (action) {
          case 'saveVideoToMyWork':
            if (params.lessonType === 1) {
              toast('临时教室不能保存')
              return
            }
            // 处理保存视频到我的作品的逻辑
            uploadWorkVideo({
              lessonId: params.lessonId,
              timesId: params.lessonTimeId,
              lessonType: params.lessonType,
              url: message.videoUrl,
              coverUrl: message.videoCoverUrl,
              width: message.videoCoverWidth,
              height: message.videoCoverHeight
            }).then((res) => {
              console.log('res', res)
              if (res.status === 0) {
                toast('保存作品成功')
              }
            })
            break
          case 'saveImageToMyWork':
            if (params.lessonType === 1) {
              toast('临时教室不能保存')
              return
            }
            // 处理保存视频到我的作品的逻辑
            uploadWork({
              lessonId: params.lessonId,
              timesId: params.lessonTimeId,
              lessonType: params.lessonType,
              url: message.imgUrl,
              width: message.width,
              height: message.height
            }).then((res) => {
              console.log('res', res)
              if (res.status === 0) {
                toast('保存作品成功')
              }
            })
            break
          case 'saveImagesOrVideos':
            downloadImages(message?.urls as any[], {
              openFolderWhenDone: true,
              onCompleted: (item) => {
                console.log('下载完成:', item.filename)
              }
            })
            break
          case 'sendDocumentToCanvas':
            console.log('🚀 ~ onMessage ~ sendDocumentToCanvas:', message)
            break
          default:
            try {
              // 尝试解析接收到的数据
              let urls = []
              if (typeof data === 'string') {
                urls = JSON.parse(event.data)
              } else {
                urls = data as any[]
              }

              console.log('🚀 ~ handleMessage ~ urls:', urls)

              // 如果接收到的数据是URL数组，则调用下载功能
              if (Array.isArray(urls) && urls.length > 0) {
                // 确保所有URL都是字符串
                const validUrls = urls.filter((url) => typeof url === 'string' && url.trim() !== '')
                if (validUrls.length > 0) {
                  downloadImages(validUrls, {
                    openFolderWhenDone: true,
                    onCompleted: (item) => {
                      console.log('下载完成:', item.filename)
                    }
                  })
                } else {
                  console.error('没有有效的图片URL')
                }
              }
            } catch (error) {
              console.error('处理消息时出错:', error)
            }
            break
        }
      } catch (error) {
        console.error('处理消息时出错:', error)
      }
    }

    window.onmessage = onMessage

    // 组件卸载时移除事件监听器
    return () => {
      window.onmessage = null
      cleanup()
    }
  }, [url])

  // const getIframeVideo = async () => {
  //   try {
  //     console.log('🚀 ~ getDomVideo ~ webviewRef.current:', webviewRef.current)

  //     if (!canvasRef.current || !iframeRef.current) return

  //     const canvas = canvasRef.current
  //     const iframe = iframeRef.current

  //     // 设置Canvas大小与iframe相同
  //     canvas.width = iframe.offsetWidth
  //     canvas.height = iframe.offsetHeight

  //     // 先绘制一些内容到canvas上，避免黑屏
  //     const ctx = canvas.getContext('2d')
  //     if (ctx) {
  //       ctx.fillStyle = 'white'
  //       ctx.fillRect(0, 0, canvas.width, canvas.height)
  //       ctx.font = '20px Arial'
  //       ctx.fillStyle = 'black'
  //       ctx.fillText('正在加载内容...', canvas.width / 2 - 80, canvas.height / 2)
  //     }

  //     // 开始持续捕获
  //     startContinuousCapture(iframe, canvas)

  //     // 创建一个视频流
  //     const stream = canvas.captureStream(25) // 25fps
  //     streamRef.current = stream

  //     const [custom] = stream.getVideoTracks()
  //     startVideoShare(custom)

  //     setTimeout(() => {
  //       stopVideoShare()
  //     }, 1000 * 10)
  //   } catch (error) {
  //     console.error('获取源时出错:', error)
  //   }
  // }

  // const checkIframeSameOrigin = (iframe: HTMLIFrameElement): boolean => {
  //   try {
  //     return !!iframe.contentWindow?.location.href
  //   } catch (e) {
  //     return false
  //   }
  // }

  // const startContinuousCapture = (iframe: HTMLIFrameElement, canvas: HTMLCanvasElement) => {
  //   // 取消之前的动画帧
  //   if (animationFrameId.current) {
  //     cancelAnimationFrame(animationFrameId.current)
  //   }

  //   const captureFrame = async () => {
  //     try {
  //       // 尝试使用postMessage与iframe通信，请求截图
  //       iframe.contentWindow?.postMessage({ action: 'requestScreenshot' }, '*')

  //       // 检查iframe是否同源
  //       const isSameOrigin = checkIframeSameOrigin(iframe)
  //       console.log('🚀 ~ captureFrame ~ isSameOrigin:', isSameOrigin)
  //       if (isSameOrigin) {
  //         // 如果iframe同源，尝试直接捕获iframe内容
  //         try {
  //           const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document
  //           if (iframeDoc && iframeDoc.body) {
  //             const result = await html2canvas(iframeDoc.body, {
  //               logging: false,
  //               useCORS: true,
  //               allowTaint: true,
  //               foreignObjectRendering: true
  //             })

  //             const ctx = canvas.getContext('2d')
  //             if (ctx) {
  //               ctx.clearRect(0, 0, canvas.width, canvas.height)
  //               ctx.drawImage(result, 0, 0, canvas.width, canvas.height)
  //             }
  //           }
  //         } catch (err) {
  //           console.log('同源iframe捕获失败:', err)
  //         }
  //       } else {
  //         console.log('iframe 跨域，尝试捕获webview')
  //         // 对于跨域iframe，先尝试在iframe中注入脚本
  //         await captureWebview()
  //         if (animationFrameId.current) {
  //           cancelAnimationFrame(animationFrameId.current)
  //         }
  //       }
  //     } catch (err) {
  //       console.log('Frame capture error:', err)
  //     }
  //     // 继续下一帧
  //     animationFrameId.current = requestAnimationFrame(captureFrame)
  //   }

  //   // 开始捕获
  //   captureFrame()
  // }

  // // 捕获webview容器
  // const captureWebview = async (): Promise<boolean> => {
  //   if (!webviewRef.current || !canvasRef.current) return false

  //   try {
  //     const element = webviewRef.current as HTMLElement
  //     const result = await html2canvas(element, {
  //       logging: false,
  //       useCORS: true,
  //       allowTaint: true,
  //       backgroundColor: '#FFFFFF'
  //     })

  //     console.log('🚀 捕获webview成功')

  //     const ctx = canvasRef.current.getContext('2d')
  //     if (ctx) {
  //       ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height)
  //       ctx.drawImage(result, 0, 0, canvasRef.current.width, canvasRef.current.height)
  //       return true
  //     }
  //   } catch (err) {
  //     console.error('捕获webview失败:', err)
  //   }
  //   return false
  // }

  // const startVideoShare = async (canvas: any) => {
  //   recorder.current = useDevice

  //   setUseDevice({ ...useDevice, viceCamera: '' })
  //   await rtcClient.changeViceCamera({ deviceId: '', publish: false })
  //   await rtcClient.changeViceCamera({ deviceId: canvas.id, publish: true, custom: canvas })
  //   // rtmClient.sendMessage('ArtScreenShareControl', {
  //   //   isShow: true
  //   // })
  // }

  // const stopVideoShare = async () => {
  //   if (animationFrameId.current) {
  //     cancelAnimationFrame(animationFrameId.current)
  //   }
  //   const { viceCamera } = recorder.current
  //   setUseDevice({ ...useDevice, viceCamera })
  //   console.log('🚀 ~ stopVideoShare ~ viceCamera:', viceCamera)
  //   await rtcClient.changeViceCamera({ deviceId: '', publish: false })
  //   await rtcClient.changeViceCamera({ deviceId: viceCamera, publish: true })
  //   // 取消之前的动画帧
  // }

  // const reloadIframe = () => {
  //   iframeRef.current?.contentWindow?.location.reload()
  // }

  return (
    <div
      ref={webviewRef}
      className={`${selected ? 'flex' : 'hidden'} ${url ? 'bg-white' : ' webview-logo-bg bg-[#E2E3ED]'} flex-col w-full h-full  justify-start items-center  rounded-md rounded-tl-none  overflow-hidden `}
    >
      {/* <button className=" absolute z-[9999] left-0 top-0" onClick={reloadIframe}>
        reload
      </button> */}
      {url ? (
        <>
          <iframe ref={iframeRef} src={url?.toString()} className="w-full h-full" />
          <canvas ref={canvasRef} className="w-full h-full absolute top-0 left-0 z-[-1]" />
        </>
      ) : null}
    </div>
  )
}

export default Index
